import React from 'react'
import { Text, TextProps } from '@grupoboticario/flora-react'
import { styled, FloraVariants, forwardRef } from '@grupoboticario/flora-react-system'

const StyledTableCellText = styled(
  (props: TextProps) => <Text size="bodyMediumStandard" isTruncated {...props} />,
  {
    lineHeight: 'unset !important',
  },
)

export type TableCellTextProps = TextProps & FloraVariants<typeof StyledTableCellText>

export const TableCellText = forwardRef<'tr', TableCellTextProps>((props, forwardedRef) => {
  return <StyledTableCellText ref={forwardedRef} data-flora="table-cell-text" {...props} />
})
